import { useState } from 'react';
import { loginFields } from '@/constants/FormFields';
import Button from '@/components/Button';
import FormExtra from '@/components/FormExtra';
import Input from '@/components/Input';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useUserContext } from '@/contexts/UserContext';
import { routes } from '@/constants/routes';

const fields = loginFields;

const Login = ({ errors, setErrors }) => {
	const [loginState, setLoginState] = useState({
		email: '',
		password: '',
	});
	const [validFields, setValidFields] = useState({});
	const navigate = useNavigate();
	const { setUser, setIsLoggedIn, setRole } = useUserContext();
	const [rememberMe, setRememberMe] = useState(() => {
		return sessionStorage.getItem('rememberMe') === 'true';
	});

	const handleChange = (e) => {
		const { id, value, type } = e.target;

		let newErrors = { ...errors };
		let valid = true;

		if (!value) {
			newErrors[id] = `${id.charAt(0).toUpperCase() + id.slice(1)} is required.`;
			valid = false;
		} else {
			delete newErrors[id];
		}

		// Email validation
		if (type === 'email' && id === 'email') {
			const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
			if (!emailRegex.test(value)) {
				newErrors.email = 'Invalid email address.';
				valid = false;
			} else {
				delete newErrors.email;
			}
		}

		// Password validation - firstore default min: 6
		if (type === 'password' && id === 'password') {
			if (value.length < 6) {
				newErrors.password = 'Password must be at least 6 characters long.';
				valid = false;
			} else if (value.length > 30) {
				newErrors.password = 'Password must be less than 30 characters long.';
				valid = false;
			} else {
				delete newErrors.password;
			}
		}

		setErrors(newErrors);
		setLoginState({ ...loginState, [id]: id === 'email' ? value.toLowerCase() : value });
		setValidFields((prev) => ({ ...prev, [id]: valid }));
	};

	const handleRememberMeChange = (e) => {
		setRememberMe(e.target.checked);
		sessionStorage.setItem('rememberMe', e.target.checked);
	};

	const allFieldsValid = () => fields.every((field) => !field.isRequired || validFields[field.id]);

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (allFieldsValid()) {
			try {
				const { data } = await axios.post(`${import.meta.env.VITE_API_URL}/api/login`, loginState);

				const { first_name, last_name, email, phone_number } = data.userData;

				setUser({ first_name, last_name, email, phone_number });
				setRole(data.userData.role);
				setIsLoggedIn(true);

				toast.success('Connexion réussie', {
					position: 'top-center',
					autoClose: 800,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					theme: 'colored',
				});

				setTimeout(() => navigate('/back-office'), 1000);
			} catch (error) {				
				toast.error('Connexion refusée', {
					position: 'top-center',
					autoClose: 800,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: true,
					theme: 'colored',
				});

				setTimeout(() => navigate(0), 1000);
			}
		}
	};

	return (
		<form onSubmit={handleSubmit}>
			<div className="mb-2 -space-y-px">
				{fields.map((field) => (
					<Input
						key={field.id}
						handleChange={handleChange}
						labelText={field.labelText}
						labelFor={field.labelFor}
						id={field.id}
						name={field.name}
						type={field.type}
						isRequired={field.isRequired}
						placeholder={field.placeholder}
						fullWidthInput={true}
					/>
				))}
			</div>

			<FormExtra onRememberMeChange={handleRememberMeChange} />
			<Button handleSubmit={handleSubmit} text="Connexion" disabled={allFieldsValid()} withTopMargin={false} />
		</form>
	);
};

export default Login;
